import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getQuestions = async (payload) => {
  const builder = new UrlBuilder(`/get-question`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const qaChatbot = async (payload) => {
  const builder = new UrlBuilder(`/use-qa-agent`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const validateResponse = async (payload) => {
  const builder = new UrlBuilder(`/validate-response`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const saveApplication = async (payload) => {
  const builder = new UrlBuilder(`/save-application`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const saveChatResponse = async (payload) => {
  const builder = new UrlBuilder(`/save-chat-response`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getPrelodgementQuestions = async (payload) => {
  const builder = new UrlBuilder(`/bedrock/get-pre-lodgement-questions`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
